import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import TitleCard from '../utils/TitleCard.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'AboutView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(TitleCard, {
    title: "踏み出せ、新世界へ。",
    abst: [
      '斜向は様々なアプローチで、ちょっと新しいコンテンツをMinecraftで制作しているグループです。',
      'コマンド、リソースパック、音楽などを用いて新世界(ハスムカイ)へとお連れします。'
    ]
  }, null, 8, ["abst"]))
}
}

})